import { forEachPositionTriggerByGuid } from './forEachPositionTriggerByGuid';
import { getCommentIconsByTriggerElement } from './getCommentIconsByTriggerElement';

export const addNoCommentsClassForPositionGuid = (positionGuid: string): void => {
    forEachPositionTriggerByGuid(positionGuid, (triggerElement) => {
        const { commentActionIcon, positionCommentIcon } =
            getCommentIconsByTriggerElement(triggerElement);

        commentActionIcon?.classList.add('has-no-comments');
        positionCommentIcon?.classList.add('has-no-comments');
    });
};
